export default `
§ achievements.commitsAfter1500.title: Сова
§ achievements.commitsAfter1500.description: 70% коммитов после 15:00
§ achievements.commitsBefore1500.title: Ранняя пташка
§ achievements.commitsBefore1500.description: 70% коммитов до обеда
§ achievements.workEveryTime.title: Раб божий
§ achievements.workEveryTime.description: есть коммит на каждый час суток
§ achievements.workNotWork.title: Стрельба холостыми
§ achievements.workNotWork.description: коммиты есть, а закрытых задач нет
§ achievements.userNotWork.title: Залётный
§ achievements.userNotWork.description: это не его основной проект
§ achievements.userIsDied.title: Мёртвая душа
§ achievements.userIsDied.description: работал, но уволился
§ achievements.lessTasks.title: Зашел и вышел
§ achievements.lessTasks.description: меньше всего закрытых задач
§ achievements.moreTasks.title: Батя грит малаца
§ achievements.moreTasks.description: больше всего закрытых задач
§ achievements.everyMessageLong.title: Мастер красноречия
§ achievements.everyMessageLong.description: стабильно самые длинные подписи коммитов
§ achievements.everyMessageShort.title: Болтун находка для шпиона
§ achievements.everyMessageShort.description: стабильно, самые короткие подписи коммитов
§ achievements.shortestName.title: Размер не главное
§ achievements.shortestName.description: самое короткое имя
§ achievements.longestName.title: Азим Азиз Иль Ам Кадир Имран II
§ achievements.longestName.description: самое длинное имя
§ achievements.moreCommits.title: Мастер бекапов
§ achievements.moreCommits.description: больше всего коммитов
§ achievements.lessCommits.title: Редко но метко
§ achievements.lessCommits.description: меньше всего коммитов
§ achievements.oneCommitOneTask.title: Точно в цель
§ achievements.oneCommitOneTask.description: в среднем один коммит на задачу
§ achievements.moreLazyDays.title: Мысленно я с вами
§ achievements.moreLazyDays.description: больше всего дней без коммитов
§ achievements.lessLazyDays.title: Папа Карло
§ achievements.lessLazyDays.description: меньше всего дней без коммитов
§ achievements.zeroLazyDays.title: Ни единого разрыва
§ achievements.zeroLazyDays.description: ни одного дня без коммитов
§ achievements.moreWorkDays.title: Ценный работник
§ achievements.moreWorkDays.description: больше всего рабочих дней
§ achievements.moreScopes.title: Стартапер
§ achievements.moreScopes.description: сделал больше всего фичей
§ achievements.lessScopes.title: Щегол
§ achievements.lessScopes.description: сделал меньше всего фичей
§ achievements.moreDaysForTask.title: Улитка на склоне
§ achievements.moreDaysForTask.description: работа по задачам идёт медленнее чем у остальных
§ achievements.more2DaysForTask.title: Cо слоу
§ achievements.more2DaysForTask.description: больше двух дней на задачу
§ achievements.moreDaysInProject.title: Старожил
§ achievements.moreDaysInProject.description: больше всего дней на проекте
§ achievements.lessDaysInProject.title: А это кто?
§ achievements.lessDaysInProject.description: меньше всего дней на проекте
§ achievements.more90DaysInProject.title: Добро пожаловать
§ achievements.more90DaysInProject.description: не уволили на испытательном
§ achievements.lessDaysForTask.title: Скорострел
§ achievements.lessDaysForTask.description: одна задача занимает меньше дня
§ achievements.adam.title: Адам
§ achievements.adam.description: первый стабильный сотрудник на проекте
§ achievements.more666DaysInProject.title: Чёрт
§ achievements.more666DaysInProject.description: отработал 666 дней на проекте
§ achievements.more777DaysInProject.title: Азино 3 топора
§ achievements.more777DaysInProject.description: отработал 777 дней на проекте
§ achievements.moreRefactoring.title: Выпускающий редактор
§ achievements.moreRefactoring.description: сделал больше всех меток «рефакторинг»
§ achievements.longestMessage.title: А разговоров то было...
§ achievements.longestMessage.description: самая длинная подпись коммита за все время
§ achievements.moreTasksInDay.title: Спиди-гонщик
§ achievements.moreTasksInDay.description: рекорд по количеству закрытых задач в день
§ achievements.hasCommitFrom0to7.title: Ночной дозор
§ achievements.hasCommitFrom0to7.description: есть коммит на каждый час ночи
§ achievements.noCommitOnDay.title: Технический перерыв
§ achievements.noCommitOnDay.description: есть определенный час и день в рабочее время в который никогда не комитит
§ achievements.hasCommitEveryTime.title: Умер на работе
§ achievements.hasCommitEveryTime.description: есть коммит на час каждого дня (включая выходные)
§ achievements.commitsAfter1800.title: Делу время
§ achievements.commitsAfter1800.description: нет ни одного коммита после 18:00
§ achievements.more1488DaysInProject.title: им. Максима Марцинкевича
§ achievements.more1488DaysInProject.description: отработал 1488 дней на проекте
§ achievements.moreFix.title: Bug hunter
§ achievements.moreFix.description: больше всего закрытых багов
§ achievements.lessWorkDays.title: Дальше без меня
§ achievements.lessWorkDays.description: меньше всего рабочих дней
§ achievements.moreCreateCode.title: Созидатель
§ achievements.moreCreateCode.description: склонен больше остальных добавлять код
§ achievements.moreRemoveCode.title: Разрушитель
§ achievements.moreRemoveCode.description: склонен больше остальных удалять код
§ achievements.moreChangeCode.title: Реформатор
§ achievements.moreChangeCode.description: склонен больше остальных изменять код
§ achievements.moreStyle.title: Полиция моды
§ achievements.moreStyle.description: склонен больше остальных изменять CSS
§ achievements.moreOnHoliday.title: Нет жизни
§ achievements.moreOnHoliday.description: относительно много коммитов в нерабочее время
`;
